import React, {useState, useEffect, createContext, useContext} from 'react';
import SocketService from 'services/SocketService';
import {
  IFarmInputInvoice,
  IFarmInputQuote,
  IInputMessage,
  IQuoteMessage,
  ISupportMessage,
  IUser,
} from 'constants/interfaces';

export enum ESocketEvents {
  NEW_CUSTOMER_MESSAGE = 'supplierNewCustomerMessage',
  NEW_QUOTE = 'supplierNewQuote',
  NEW_QUOTE_MESSAGE = 'supplierNewQuoteMessage',
  NEW_INVOICE = 'supplierNewInvoice',
  NEW_INVOICE_MESSAGE = 'supplierNewInvoiceMessage',
}

export type SocketEventState = {
  newCustomerMessage?: NewCustomerMessageEvent;
  newQuote?: NewQuoteEvent;
  newQuoteMessage?: NewQuoteMessageEvent;
  newInvoice?: NewInvoiceEvent;
  newInvoiceMessage?: NewInvoiceMessageEvent;
};

const SocketEventContext = createContext({});

export const useSocketEvents = (): SocketEventState =>
  useContext(SocketEventContext);

const SocketEventProvider = (props: {children: any}) => {
  const [state, setState] = useState<SocketEventState>({});

  useEffect(() => {
    SocketService.setupSocket();
    SocketService.on(
      ESocketEvents.NEW_CUSTOMER_MESSAGE,
      handleNewCustomerMessage,
    );
    SocketService.on(ESocketEvents.NEW_QUOTE, handleNewQuote);
    SocketService.on(ESocketEvents.NEW_QUOTE_MESSAGE, handleNewQuoteMessage);
    SocketService.on(ESocketEvents.NEW_INVOICE, handleNewInvoice);
    SocketService.on(
      ESocketEvents.NEW_INVOICE_MESSAGE,
      handleNewInvoiceMessage,
    );
  }, []);

  const handleNewCustomerMessage = (
    newCustomerMessage: NewCustomerMessageEvent,
  ) => {
    setState((state) => {
      return {...state, newCustomerMessage};
    });
  };

  const handleNewQuote = (newQuote: NewQuoteEvent) => {
    setState((state) => ({...state, newQuote}));
  };

  const handleNewQuoteMessage = (newQuoteMessage: NewQuoteMessageEvent) => {
    setState((state) => ({...state, newQuoteMessage}));
  };

  const handleNewInvoice = (newInvoice: NewInvoiceEvent) => {
    setState((state) => ({...state, newInvoice}));
  };

  const handleNewInvoiceMessage = (
    newInvoiceMessage: NewInvoiceMessageEvent,
  ) => {
    setState((state) => ({...state, newInvoiceMessage}));
  };

  return (
    <SocketEventContext.Provider value={state}>
      {props.children}
    </SocketEventContext.Provider>
  );
};
export default SocketEventProvider;

export type NewCustomerMessageEvent = {
  sender: IUser;
  message: ISupportMessage;
};

export type NewQuoteEvent = {
  quote: IFarmInputQuote;
};

export type NewQuoteMessageEvent = {
  sender: IUser;
  quote: IFarmInputQuote;
  message: IQuoteMessage & {textMessage: string};
};

export type NewInvoiceEvent = {
  invoice: IFarmInputInvoice;
};

export type NewInvoiceMessageEvent = {
  sender: IUser;
  invoice: IFarmInputInvoice;
  message: IInputMessage & {textMessage: string};
};
